import { getLangFallbackUrl } from '~/lang/utils/langfetch'
import { CampsiteReviewFilterOption } from './domain'

export class AjaxCampsiteReviewFilterOptionsRepository {
  async readAll(langCode: string): Promise<CampsiteReviewFilterOption[]> {
    return await $fetch<CampsiteReviewFilterOption[]>(
      getLangFallbackUrl(langCode, '/_/campsite-review-filter-options/'),
    )
  }
}
